import { createSlice } from '@reduxjs/toolkit';

export interface AccessState {
  forbidden: boolean;
}

const initialState: AccessState = { forbidden: false };

const accessSlice = createSlice({
  name: 'access',
  initialState,
  reducers: {
    setForbidden(state) {
      state.forbidden = true;
    },
    clearForbidden(state) {
      state.forbidden = false;
    },
  },
});

export const { setForbidden, clearForbidden } = accessSlice.actions;
export default accessSlice.reducer;
